import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=ce4624ca&scoped=true"
import script from "./LogoutPage.vue?vue&type=script&lang=ts"
export * from "./LogoutPage.vue?vue&type=script&lang=ts"
import style0 from "./LogoutPage.vue?vue&type=style&index=0&id=ce4624ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4624ca",
  null
  
)

export default component.exports